export default __webpack_public_path__ + "static/media/sound-icon.071a35fb.svg";